import React from "react"
import { Icon } from "semantic-ui-react"
import { ReactComponent as EthernetIcon } from "../../Icons/ethernet.svg"

const InterfaceIcon = ({ data, size }) => {
	const iconSize = size ? size : null // todo this should be null, I was change it from "" to null. that should be fixed by another commit
	const fontsize = size === "tiny" ? "16px" : "14px"

	return (
		<>
			{!data.activeIface ? (
				<Icon name="signal" size={iconSize} style={{ margin: "0 0.5rem 0 0", height: "100%" }} color="grey" />
			) : data.activeIface.toLowerCase() === "ethernet" ? (
				<EthernetIcon style={{ margin: "0 0.5rem 0 0", height: "16px", color: "grey" }} />
			) : data.activeIface.toLowerCase() === "wifi" ? (
				<Icon size={iconSize} name="wifi" style={{ margin: "0 0.5rem 0 0", height: "100%" }} color="grey" />
			) : (
				<p style={{ fontSize: fontsize, fontWeight: "bold", color: "grey", margin: "0 0.5rem 0 0" }}>4G</p>
			)}
		</>
	)
}

export default InterfaceIcon
